import React from "react";
import Image from "components/image";
import { useGlobalContext } from "context/global";
import Money from "components/money";
import { formatTitle } from "helpers/format-title";
import clsx from "clsx/lite";

const BundleChoice = ({ bundle, frequency, cartSummary, hideBundle }) => {
	const { translation, cartSettings } = useGlobalContext();
	const activeBox = cartSettings.boxes.find(box => box.size.value === bundle.mealsPerWeek * bundle.frequency.intervalCount);
	const { savings, pricePerMeal, highestBoxPrice } = cartSummary;

	const product = bundle.product;

	const handleClick = () => {
		document.querySelector("#bundle-products").scrollIntoView({ behavior: "smooth", block: "start" });
	};

	return (
		<div className="mt-7 mb-2">
			{!hideBundle && <>
				<h3>{translation.shopping_flow?.your_selection}</h3>
				<div className="flex justify-between items-center pt-3 pb-8 border-b">
					<button className="flex gap-x-5 w-4/5 items-center" onClick={handleClick}>
						{product.images?.length > 0 &&
							<Image image={product.images[0]} className="w-2/5 lg:w-1/4 cursor-pointer" />}
						<div className="text-left w-fit">
							<h4>{formatTitle(product.title)}</h4>
							<p className="lowercase text-secondary !cursor-auto"
								onClick={(e) => e.stopPropagation()} role="button" tabIndex={0}
							>
								{activeBox.size.value} {translation.cart.meals} {translation.shopping_flow.delivered} <br />
								{frequency.name}
							</p>
						</div>
					</button>
				</div>
			</>}
			<div className={clsx("flex justify-between items-center", !hideBundle && "mt-8")}>
				<div>
					<span className="font-boldParagraph">
						{translation.shopping_flow?.in_total}{" "}
					</span>
					<span className="font-boldParagraph">
						{activeBox.size.value} {translation.cart.meals}{" "}
						<span className="lowercase font-boldParagraph">{translation.other.for}</span>
						<br />
						{savings > 0 &&
							<span className="line-through font-thin text-secondary mr-1"
								aria-label={`Original price: ${highestBoxPrice}`}>
								<Money value={highestBoxPrice} />
							</span>}
						<span className="font-boldParagraph">
							<Money value={pricePerMeal} />{" "}
						</span>
						{translation.cart.per_meal}
					</span>
				</div>
				{savings > 0 &&
					<span className="bg-green-discount px-4 py-1.5 text-small rounded-6xl">
						{translation.other.save_money} -<Money value={savings} minimumFractionDigits={0} />
					</span>
				}
			</div>
		</div >
	);
};

export default BundleChoice;